import { isNil } from "@etudescarre/utils";
import { apiClient } from "@/lib/api/client";
import type { paths } from "@/lib/api/schema";

export type AdminCompanyListItem =
  paths["/api/admin/companies"]["get"]["responses"][200]["content"]["application/json"]["data"]["companies"][number];

export type FetchAllCompaniesResult =
  | { companies: AdminCompanyListItem[]; status: number }
  | { companies: null; status: number };

const PAGE_SIZE = 100;

export async function fetchAllCompanies(): Promise<FetchAllCompaniesResult> {
  const companies: AdminCompanyListItem[] = [];
  let page = 1;

  for (;;) {
    const { data, response } = await apiClient.GET("/api/admin/companies", {
      params: { query: { page, pageSize: PAGE_SIZE } },
    });
    if (isNil(data)) {
      return { companies: null, status: response.status };
    }
    companies.push(...data.data.companies);
    if (
      data.data.companies.length < PAGE_SIZE ||
      companies.length >= data.data.total
    ) {
      return { companies, status: response.status };
    }
    page += 1;
  }
}
